var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{ref:"vField",class:{ required: _vm.required },attrs:{"name":_vm.$attrs.title,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('md-field-item',_vm._g(_vm._b({class:{
      unrequired: !_vm.required,
      'has-error': errors.length,
    },on:{"click":_vm.handleClick}},'md-field-item',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2),(errors.length > 0)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(errors[0]))]):_vm._e()]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }